module.exports = __webpack_public_path__ + "static/media/pushpa.d19b4597.jpg";